module.exports = __webpack_public_path__ + "media/images/sidebar_questionnaire-fc3f66620fe5616fb4d5bce48b917b0e.png";